import { render, staticRenderFns } from "./DCalc.vue?vue&type=template&id=90f2cf6a&"
import script from "./DCalc.vue?vue&type=script&lang=js&"
export * from "./DCalc.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports